import { useInterval } from 'app/services';
import moment from 'moment/moment';
import React, { useState } from 'react';

const MapTransportConditionTimer = ({ lastTime }) => {
  const [currentTime, setCurrentTime] = useState(moment());

  useInterval(() => {
    setCurrentTime(moment());
  }, 1000);
  const time = moment.utc(currentTime.diff(moment(lastTime)));
  return <React.Fragment>{time > 0 ? time.format('HH:mm:ss') : '00:00:00'}</React.Fragment>;
};

export default MapTransportConditionTimer;
